import { gql } from '@apollo/client'

export const ITINERARY_QUERY = gql`
  query ($id: ID!) {
    itineraryPreview(id: $id) {
      html
    }
  }
`
